<app-cards-generator
    [cardInput]="cardInput"
    [widgetRef]="widgetRef"
    [showPagination] = 'true'
></app-cards-generator>
